<template>
    <v-container>

        <v-row>
            <v-col>
                <v-select v-model="listOneSelected" color="#c42111" :items="listOne" @change="onChange" />
            </v-col>
            <v-col>
                <v-select v-model="listTwoSelected" color="#c42111" :items="listTwo" @change="onChange" />
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
export default {
  name: 'DoubleSelect',
  props: ['param'],
  data: () => ({
      listOneSelected: null,
      listOne: [],
      listTwoSelected: null,
      listTwo: [],
  }),

  computed: {
    
  },

  methods: {
      onChange: function(val) {
            let selectedValue = '';
            selectedValue += `${this.listOne.indexOf(this.listOneSelected)} `;
            selectedValue += `${this.listTwo.indexOf(this.listTwoSelected)}`;
            this.param.selectedValue = selectedValue;
            this.param.humanText = `${this.listOneSelected}; ${this.listTwoSelected}`;

            this.$emit('edit');
      },

      buildList: function() {
            let paramValues = this.param.rpt_param_values.slice(0);
            let paramValuesArray = [[],[]];
            let inner = 0;
            for(let i = 0; i < paramValues.length; i++) {
                let paramValue = paramValues[i];
                if(paramValue !== "") {
                    paramValuesArray[inner].push(paramValue);
                }
                else {
                    inner += 1;
                }
            }
            this.listOne = paramValuesArray[0];
            this.listTwo = paramValuesArray[1];
            this.listOneSelected = this.listOne[0];
            this.listTwoSelected = this.listTwo[0];
      },

      setInputsInitialValue: function() {
          if(this.$props.param.encodedValue == undefined) {
              return;
          }
          const value = this.$props.param.encodedValue.split(' ');
          this.listOneSelected = this.listOne[parseInt(value[0])];
          this.listTwoSelected = this.listTwo[parseInt(value[1])];
      }
  },

  mounted() {
    this.buildList();
    this.setInputsInitialValue();
    this.onChange();
  }

  
};
</script>

<style scoped>


</style>

